// extracted by mini-css-extract-plugin
export var cardSelected = "_gj-2";
export var image = "_gj-1";
export var table = "_gj-0";